import React from 'react';
import { observer } from 'mobx-react';

import { ComponentRegistry } from 'core/index';
import { Option, OptionWrapper } from 'libs/forms/styles';

import { HighlightedSelection } from 'apps/autocomplete/views/highlightedSelection';

export const TagAutoComplete = observer(
  ({
    app,
    selection,
    highlighted,
    onClick,
    onMouseOver,
    scrollRef,
    labelKey,
  }) => {
    return (
      <OptionWrapper
        ref={scrollRef}
        highlighted={highlighted}
        onMouseOver={onMouseOver}
        onClick={onClick}
      >
        <Option highlighted={highlighted}>
          <HighlightedSelection
            optionText={app[labelKey] || ''}
            selection={selection}
          />
        </Option>
      </OptionWrapper>
    );
  },
);

ComponentRegistry.add('tags.autocompleteElement', TagAutoComplete);
